module.exports = __webpack_public_path__ + "static/media/snowflakes.5a765b16.svg";